import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, Output, EventEmitter } from '@angular/core'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { StripeCardElementOptions, StripeCardElementChangeEvent } from '@stripe/stripe-js'
import { StripeCardComponent, StripeInstance } from 'ngx-stripe'
import { finalize } from 'rxjs'

@Component({
  selector: 'lin-add-card-form',
  templateUrl: './add-card-form.component.html',
  styleUrls: ['./add-card-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddCardFormComponent implements OnInit {
  @Input() stripe: StripeInstance
  @Input() clientSecret: string
  @Input() paymentMethodCreating = false
  @Output() savePaymentMethod = new EventEmitter()
  @ViewChild(StripeCardComponent, { static: false }) card: StripeCardComponent

  cardForm: FormGroup
  cardError: string
  cardComplete: boolean
  isSubmitting = false

  cardOptions: StripeCardElementOptions = {
    iconStyle: 'solid',
    style: {
      base: {
        fontWeight: 500,
        fontFamily: 'Roboto, Helvetica Neue, Arial, sans-serif',
        fontSize: '16px',
        fontSmoothing: 'antialiased',
      },
    },
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.cardForm = this.fb.group({
      name: ['', [Validators.required]],
    })
  }

  saveCard() {
    const name = <string>this.cardForm.get('name').value

    this.isSubmitting = true
    this.stripe
      .confirmCardSetup(`${this.clientSecret}`, {
        payment_method: {
          card: this.card.element,
          billing_details: {
            name: name,
          },
        },
      })
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe((result) => {
        if (result.error) {
          this.cardError = result.error.message
        } else {
          this.savePaymentMethod.emit(<string>result.setupIntent.payment_method)
          this.clearCard()
        }
      })
  }

  cardHandler(event: StripeCardElementChangeEvent): void {
    this.cardError = null
    if (event.complete) {
      this.cardComplete = true
    } else if (event.error) {
      this.cardError = event.error.message
      this.cardComplete = false
    }
  }

  clearCard(): void {
    this.cardForm.reset()
    this.cardForm.markAsUntouched()
    this.cardForm.get('name').setErrors(null)

    this.card.element.clear()
    this.cardComplete = false
  }
}
